import { getAccountsQueryConfig } from '@api/lendingAPI/queryConfigs';
import { getDurationInMonths } from '@helpers/GetDurationInMonths/getDurationInMonths';
import { useQuery } from '@tanstack/react-query';
import { Text } from '@ui';
import { FormattedMessage } from 'react-intl';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';
import ProductType from '../../../ui/productType/ProductType';
import { Rate } from '../../../ui/rate';
import { getMaxMonthlyInterestRate } from '../../NewOutstandingView/NewOutstandingView.helpers';
import InternationalisedName from '../InternationalisedName';

export const LoanInformationHeader = ({ accountId }: { accountId: string }) => {
    const stateKey = useStateKey();

    const {
        data: getAccountsResponse,
        isLoading,
        isError
    } = useQuery(getAccountsQueryConfig(stateKey));

    // TODO: Improve loading skeleton
    if (isLoading || isError) return null;
    const account = getAccountsResponse.data?.accounts.find(
        (account) => account.account_id === accountId
    )!;

    if (account) {
        const productType = account.product_type;

        const durationInMonths = getDurationInMonths(account.duration!);

        const interestRate = getMaxMonthlyInterestRate(account);

        return (
            <>
                <Text className="font-med">
                    <FormattedMessage
                        id="_.outstanding_view.greeting"
                        defaultMessage="Hello, {name}"
                        values={{ name: <InternationalisedName /> }}
                    />
                </Text>
                <Text>
                    <FormattedMessage
                        id="_.outstanding_view.yourlookingat"
                        defaultMessage="You're looking at your"
                    />{' '}
                    <ProductType
                        productType={productType!}
                        durationInMonths={durationInMonths}
                    />
                    <FormattedMessage
                        id="_.outstanding_view.youllPay"
                        defaultMessage=". You're paying {approvalInterestRate} interest per month."
                        values={{
                            approvalInterestRate: <Rate value={interestRate!} />
                        }}
                    />
                </Text>
            </>
        );
    }
    return null;
};
